import { ICurrentLang } from './type';

const LANGUAGE_LABELS: Record<string, string> = {
  en: 'English',
  nl: 'Dutch'
};

const useLanguage = (
  tenantSiteLanguages: string[] = []
): { LANGS: ICurrentLang[] } => {
  const languagesToUse =
    tenantSiteLanguages && tenantSiteLanguages.length > 0
      ? tenantSiteLanguages
      : ['en'];

  const LANGS: ICurrentLang[] = languagesToUse.map((lang) => ({
    value: lang,
    label: LANGUAGE_LABELS[lang] || lang.toUpperCase(),
    icon1: `${lang}.svg`
  }));

  return { LANGS };
};

export default useLanguage;
